<template>
  <div class="card shadow-sm p-3 mb-3 pb-4">
    <div class="row g-2">
      <div class="col-md-2">
        <label class="form-label small">Start Date</label>
        <input
          v-model="localFilters.startDate"
          type="date"
          class="form-control form-control-sm"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label small">End Date</label>
        <input
          v-model="localFilters.endDate"
          type="date"
          class="form-control form-control-sm"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label small">Type</label>
        <select v-model="localFilters.type" class="form-select form-select-sm">
          <option value="">All</option>
          <option value="error">Errors</option>
          <option value="warning">Warnings</option>
          <option value="info">Info</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label small">Device ID</label>
        <select
          v-model="localFilters.deviceId"
          class="form-select form-select-sm"
        >
          <option value="">Any</option>
          <option v-for="device in devices" :key="device.id" :value="device.id">
            {{ device.name }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label small">Sort By</label>
        <select v-model="localFilters.sort" class="form-select form-select-sm">
          <option value="id|desc">ID (High → Low)</option>
          <option value="id|asc">ID (Low → High)</option>
          <option value="date|desc">Date (Newest First)</option>
          <option value="date|asc">Date (Oldest First)</option>
          <option value="type|asc">Type (A → Z)</option>
          <option value="type|desc">Type (Z → A)</option>
          <option value="deviceId|asc">Device ID (Low → High)</option>
          <option value="deviceId|desc">Device ID (High → Low)</option>
        </select>
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button class="btn btn-warning btn-sm px-5" @click="applyFilters">
          Apply
        </button>
        <button class="btn btn-outline-secondary btn-sm ms-2" @click="exportData">
          Export
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import messageService from "@/services/messageService";

export default {
  name: "DeviceMessageFilters",
  props: {
    filters: Object,
    devices: Object,
  },
  emits: ["update:filters"],
  data() {
    const today = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(today.getDate() - 7);

    const formatDate = (date) => {
      return date.toISOString().split("T")[0];
    };

    return {
      localFilters: {
        sort: "id|desc",
        startDate: formatDate(oneWeekAgo),
        endDate: formatDate(today),
        type: "",
        deviceId: "",
        ...this.filters,
      },
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(newFilters) {
        this.localFilters = {
          sort: "id|desc",
          startDate: this.localFilters.startDate,
          endDate: this.localFilters.endDate,
          type: this.localFilters.type,
          deviceId: this.localFilters.deviceId,
          ...newFilters,
        };
      },
    },
  },
  methods: {
    applyFilters() {
      this.$emit("update:filters", { ...this.localFilters });
    },
    async exportData() {
      try {
        const blob = await messageService.exportMessages(this.localFilters);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "messages.csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Export failed:", error);
      }
    },
  },
};
</script>